import { array, arrayOf, shape, string } from 'prop-types';

export const userTypes = shape({
  country: string,
  email: string,
  extension: string,
  firstName: string,
  id: string,
  lastName: string,
  locale: string,
  phoneNumber: string,
  role: string,
  status: string,
  timeZone: string,
  username: string,
  accountDepartments: array
});

export const departmentTypes = shape({
  customerDepartmentCode: string.isRequired,
  customerDepartmentName: string.isRequired
});

export const custDepartmentTypes = shape({
  customerNumber: string,
  customerName: string,
  customerDepartments: arrayOf(departmentTypes)
});

export const departmentsTypes = arrayOf(custDepartmentTypes);

export const userAccountTypes = shape({
  number: string,
  name: string
});

export const userDepartmentTypes = shape({
  deptNames: arrayOf(string),
  deptNumbers: arrayOf(string),
  depts: arrayOf(departmentTypes)
});

export const gamedayAccountTypes = shape({
  accountNumber: string
});

export const accountDetailTypes = shape({
  customerName: string,
  customerCountryCode: string,
  salesOrgCode: string,
  region: string,
  pricelistType: string,
  languages: arrayOf(string)
});
